import { Capacitor } from '@capacitor/core'

import { mixpanel } from '@/mixpanel'
import { openUrl } from '@/utils/external-resources'

import type { Address } from '@/modules/appointment/types/location.types'

function navigateMaps(address: Address | string | undefined) {
  let addressString

  if (typeof address === 'string') {
    addressString = address
  } else if (address) {
    addressString = encodeURIComponent(`${address?.street} ${address?.city} ${address?.postcode}`)
  }

  if (!addressString) {
    return
  }

  mixpanel.track('home_feed_navigation')
  // Create the maps url based on the device platform
  const platform = Capacitor.getPlatform() === 'android' ? 'google' : 'apple'
  const url = `http://maps.${platform}.com?daddr=${addressString ?? 'null'}`
  openUrl(url)
}

export { navigateMaps }
